import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import {
  Table,
  Input,
  InputNumber,
  Popconfirm,
  Form,
  Typography,
  Space,
  DatePicker,
  Col,
  Row,
  Button,
  Select,
  Spin,
  Checkbox,
} from 'antd';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';
import { getLessonDaysFromFreqList } from '../../../utilities/dateHelper';
import { connect } from 'react-redux';
import { setCurrentUnitOffer } from '../../../actions/unitOffer';
import { debounce } from '../../../components/Common/Debounce';
import { getUnits } from '../../../services/unitService';

const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  record,
  index,
  children,
  ...restProps
}) => {
  const [fetching, setFetching] = useState(false);
  const [fetchedUnits, setFetchedUnits] = useState([]);
  const [fetchedUnitCodes, setFetchedUnitCodes] = useState([]);

  const fetchUnitsHandler = debounce((unitSearch, type) => {
    setFetching(true);
    getUnits(0, 0, {
      unitSearch,
    })
      .then((response) => {
        const data = response.data.paginatedList.map((unit) => {
          if (type === 'id') {
            return {
              label: `${unit.description} - ID: ${unit.unitId}`,
              value: unit.unitId,
            };
          } else if (type === 'code') {
            return {
              label: `${unit.code}`,
              value: unit.code,
            };
          }
        });
        if (type === 'id') {
          setFetchedUnits(data);
        } else if (type === 'code') {
          setFetchedUnitCodes(data);
        }
        setFetching(false);
      })
      .catch((err) => {});
  }, 250);

  let inputNode;
  if (dataIndex === 'startDate' || dataIndex === 'endDate') {
    inputNode = (
      <DatePicker
        showTime={true}
        showNow={false}
        format={dateFormat}
        style={{ width: '100%' }}
      />
    );
  } else if (dataIndex === 'unitId') {
    inputNode = (
      <Select
        mode={''}
        placeholder="Search units"
        options={fetchedUnits}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        showSearch={true}
        onSearch={(value) => fetchUnitsHandler(value, 'id')}
        style={{ width: '100%' }}
      />
    );
  } else if (dataIndex === 'code') {
    inputNode = (
      <Select
        mode={''}
        placeholder="Search units"
        options={fetchedUnitCodes}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        showSearch={true}
        onSearch={(value) => fetchUnitsHandler(value, 'code')}
        style={{ width: '100%' }}
      />
    );
  } else {
    inputNode = <Input />;
  }
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const EditableUnitOfferTable = ({
  unitOffers,
  setTotalCount,
  courseOffer,
  dispatch,
}) => {
  const [form] = Form.useForm();
  const [data, setData] = useState(
    unitOffers.map((unitOffer) => {
      return {
        ...unitOffer,
        startDate: moment(unitOffer.startDate),
        endDate: moment(unitOffer.endDate),
      };
    })
  );
  const [editingKey, setEditingKey] = useState('');
  const [lessonStartDates, setLessonStartDates] = useState([]);
  const [lessonEndDates, setLessonEndDates] = useState([]);
  const [timeCheckbox, setTimeCheckbox] = useState(false);

  const isEditing = (record) => data.indexOf(record) === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      code: '',
      description: '',
      startDate: '',
      endDate: '',
      courseOffer: '',
      ...record,
    });
    setEditingKey(data.indexOf(record));
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === data.indexOf(item));

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setData(newData);
        dispatch(setCurrentUnitOffer(newData));
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const add = (index) => {
    let newData = data;
    newData.splice(index, 0, {
      isActive: true,
      minRegistrations: 0,
      maxRegistrations: 0,
      endDate: null,
      startDate: null,
      courseOfferId: '',
      unitId: null,
      courseOffer: {},
      unitCode: '',
      unitDescription: '',
      code: '',
      createdAt: new Date(),
      lastModifiedTimeStamp: new Date(),
      unitOfferId: '',
    });
    newData = [...newData];
    setData(newData);
    setTimeForUnitOffers();
    dispatch(setCurrentUnitOffer(newData));
    setTotalCount(newData.length);
    setEditingKey('');
  };

  const deleteItem = (index) => {
    let newData = data;
    newData.splice(index, 1);
    newData = [...newData];
    setData(newData);
    setTimeForUnitOffers();
    dispatch(setCurrentUnitOffer(newData));
    setTotalCount(newData.length);
  };

  const setTimeForUnitOffers = () => {
    const unitOfferWithTime = data.map((unitOffer, index) => {
      return {
        ...unitOffer,
        startDate: moment(lessonStartDates[index]),
        endDate: moment(lessonEndDates[index]),
      };
    });
    setData(unitOfferWithTime);
    dispatch(setCurrentUnitOffer(unitOfferWithTime));
  };

  const getLessonDays = (date, frequency, allSameTime) => {
    const unitCount = data.length;
    return getLessonDaysFromFreqList(date, frequency, unitCount, allSameTime);
  };

  useEffect(() => {
    const courseOfferStart = courseOffer.startDate;
    const lessonStart = new Date(
      moment(courseOfferStart).format('YYYY-MM-DD HH:mm:ss')
    );
    const courseOfferEndDate = courseOffer.endDate;
    const courseOfferEnd = moment(courseOffer.startDate);
    courseOfferEnd.set({
      hour: courseOfferEndDate.get('hour'),
      minute: courseOfferEndDate.get('minute'),
      second: courseOfferEndDate.get('second'),
    });
    const lessonEnd = new Date(
      moment(courseOfferEnd).format('YYYY-MM-DD HH:mm:ss')
    );
    setLessonStartDates(
      getLessonDays(lessonStart, courseOffer.frequency, timeCheckbox)
    );
    setLessonEndDates(
      getLessonDays(lessonEnd, courseOffer.frequency, timeCheckbox)
    );
  }, [courseOffer, timeCheckbox]);

  useEffect(() => {
    dispatch(setCurrentUnitOffer(unitOffers));
  }, [unitOffers]);

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      editable: true,
      render: (text, record) => (
        <Space style={{ width: '100px' }}>
          <Link to={`/unit-offer/${record.unitOfferId}`}>{text}</Link>
        </Space>
      ),
    },
    {
      title: 'Unit',
      dataIndex: 'unitId',
      editable: true,
      render: (value, record) => (
        <span>
          {value ? `${record.unitDescription} - ID: ${record.unitId}` : null}
        </span>
      ),
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      editable: true,
      sortDirections: ['descend', 'ascend'],
      render: (text) => (
        <div>{text ? moment(text).local().format(dateFormat) : null}</div>
      ),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      editable: true,
      render: (text) => (
        <div>{text ? moment(text).local().format(dateFormat) : null}</div>
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'operation',
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <a
              href="javascript:;"
              onClick={() => save(index)}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </a>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Row>
            <Col style={{ marginRight: '5px' }}>
              <Typography.Link
                disabled={editingKey !== ''}
                onClick={() => edit(record)}
              >
                Edit
              </Typography.Link>
            </Col>
            <Col style={{ marginRight: '5px' }}>
              <Typography.Link onClick={() => add(index + 1)}>
                Add
              </Typography.Link>
            </Col>
            <Col>
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => deleteItem(index)}
              >
                <a>Delete</a>
              </Popconfirm>
            </Col>
          </Row>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Form form={form} component={false}>
      <Row style={{ float: 'right', marginBottom: '12px' }}>
        <Col style={{ marginRight: '5px' }}>
          <Button
            type="primary"
            onClick={() => setTimeForUnitOffers()}
            style={{ float: 'right', marginBottom: '12px', marginRight: '5px' }}
          >
            Update lesson time
          </Button>
        </Col>
        <Col>
          <Checkbox
            checked={timeCheckbox}
            onChange={() => {
              setTimeCheckbox(!timeCheckbox);
            }}
          >
            All same time
          </Checkbox>
        </Col>
        {data.length === 0 && (
          <Col style={{ marginRight: '5px' }}>
            <Button type="primary" onClick={() => add(0)}>
              Add row
            </Button>
          </Col>
        )}
      </Row>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={data}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          defaultPageSize: 20,
        }}
      />
    </Form>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(EditableUnitOfferTable));
